import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { config as CONFIG } from "app/app.config";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { FormControl } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { Filtro } from "app/main/apps/shared/interfaces/filtro.interface";
import { FiltrosService } from "app/main/apps/shared/services/util/filtros.service";
import { MatChipInputEvent } from '@angular/material/chips';
import { FiltroFactura } from 'app/main/apps/shared/interfaces/filtro-factura.interface';
import { ClienteDTO } from 'app/main/apps/shared/interfaces/cliente.interface';

@Component({
  selector: 'app-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss']
})
export class SearchboxComponent implements OnInit , OnDestroy{

  @Output()
  filtrarFactura: EventEmitter<FiltroFactura> = new EventEmitter();
  filtros: FiltroFactura;

  @ViewChild("estadoInput") estadoInput: ElementRef<HTMLInputElement>;
  @ViewChild("clienteInput") clienteInput: ElementRef<HTMLInputElement>;
  @ViewChild("nombreInput") nombreInput: ElementRef<HTMLInputElement>;
  @ViewChild("rutInput") rutInput: ElementRef<HTMLInputElement>;
  @ViewChild("nroFacturaInput") nroFacturaInput: ElementRef<HTMLInputElement>;
  
  @Input() estados: Filtro[];
  @Input() clientes: ClienteDTO[];
  subscripciones: Subscription;

  filteredEstados: Observable<any[]>;
  filteredClientes: Observable<ClienteDTO[]>;

  estadoCtrl = new FormControl();
  clienteCtrl = new FormControl();
  nombreCtrl = new FormControl();
  rutCtrl = new FormControl();
  nroFacturaCtrl = new FormControl();

  config;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(private _filtroSrvc: FiltrosService) { 
    this.config = CONFIG;
    this.filtros = this._filtroSrvc.getFiltro("filtrosFacturas");
    this.subscripciones = new Subscription();

    this.filteredClientes = this.clienteCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
          value
              ? this._filter(value, "nombre", this.clientes)
              : this.clientes.slice()
      )
    );

    this.filteredEstados = this.estadoCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
          value
              ? this._filter(value, "descripcion", this.estados)
              : this.estados.slice()
      )
    );
  }
  ngOnDestroy(): void {
    this.limpiarTodosFiltros();
  }


  private _filter(
    value: string | any,
    columnaAFiltrar: string,
    listaDeValoresAfiltrar: any[]
  ): any[] {
    let filterValue: string;
    if (typeof value === "object") {
        filterValue = value[columnaAFiltrar].toLowerCase();
    } else {
        filterValue = value.toLowerCase();
    }

    return listaDeValoresAfiltrar.filter((item) =>
        item[columnaAFiltrar].toLowerCase().includes(filterValue)
    );
  }


  agregarFiltro(
    event: MatChipInputEvent,
    controller: any,
    filtroSeleccionado: string
  ) {
    const input = event.input;
    const value = event.value;
    if ((value || "").trim()) {
        this._filtroSrvc.setFiltro(
            "filtrosFacturas",
            filtroSeleccionado,
            value.trim(),
            value.trim()
        );
    }

    if (input) {
        input.value = "";
    }

    controller.setValue(null);
}


  seleccionarFiltro(
    event: MatAutocompleteSelectedEvent,
    columnaValor: string,
    columnaDescripcion: string,
    controller: any,
    input: string,
    filtroSeleccionado: string
) {
    const valor = event.option.value[columnaValor];
    const descripcion = event.option.value[columnaDescripcion];

    this._filtroSrvc.setFiltro(
        "filtrosFacturas",
        filtroSeleccionado,
        valor,
        descripcion
    );
    this[input].nativeElement.value = "";
    controller.setValue(null);
    this.filtros = this._filtroSrvc.getFiltro("filtrosFacturas");
}

limpiarTodosFiltros() {
  this._filtroSrvc.initFiltrosOOCC();
  this.filtros = this._filtroSrvc.getFiltro("filtrosFacturas");
  this.filtrar();
}

quitarFiltro(nombreFiltro: string) {
  this._filtroSrvc.resetFiltro("filtrosFacturas", nombreFiltro);
}


filtrar() {
  this.filtrarFactura.emit(this.filtros);
}

ngOnInit(): void {
  this.subscripciones.add(
    this._filtroSrvc.filtrosFacturasLoaded$.subscribe((filtros) => {
        this.filtros = filtros;
    })
);
}

}
